var map = {
	"./en.json": 2228,
	"./es.json": 7491,
	"./pt.json": 7375
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2249;
module.exports = webpackAsyncContext;